import React from 'react'
import BooleanDropdown from '../boolean_dropdown'
import Input from '../forms/input'

export default class Kitchen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      attributes: props.details.attributes === undefined ? '' : props.details.attributes,
      roomIndex: props.roomIndex,
      roomId: props.details.id === undefined ? '' : props.details.id
    }
  }

  render() {
    const namePrefix = `property[rooms_attributes][${this.state.roomIndex}]`;

    return (
      <div>
        <input className="hidden" type="hidden" value={this.state.roomId} name={`${namePrefix}[id]`}/>
        <input className="hidden" type="hidden" value="Kitchen" name={`${namePrefix}[class]`}/>

        <Input label="Room size" className="room-size" name={`${namePrefix}[room_size]`} defaultValue={this.state.attributes.room_size} addOnAfter="m&sup2;" />

        <BooleanDropdown componentLabel="Open Plan" componentName={`${namePrefix}[open_plan]`} defaultValue={this.state.attributes.open_plan} />
      </div>
    )
  }
}
